module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp2_8019.5640bf7e.png";